export const ResConfig = {
  //资源根目录
  "root-address": "https://web-res-ccc.afunimg8.com/",
  //文件目录
  "files-address": "https://web-res-ccc.afunimg8.com/s_static/files/",
  //游戏icon目录
  "game-icon-folder": "newres/gameicon_en6020",
  //游戏icon地址集合
  "game-icon": [
    "https://web-res-aaa.afunimg5.com/cdn-cgi/image/format=auto/",
    // 'https://web-res-ddd.afunimg6.com/cdn-cgi/image/format=auto/',
    // 'https://web-res-bbb.afunimg7.com/cdn-cgi/image/format=auto/',
    "https://web-res-ccc.afunimg8.com/cdn-cgi/image/format=auto/",
  ],
  //游戏icon图片文件类型
  "game-icon-type": "jpg",
  // winner游戏厂商图标
  "plat-icon-folder-winner": "newres/platicon_winner_dark",
  "plat-icon-folder": "newres/platicon",
};

export type TResConfig = keyof typeof ResConfig;

export const Skin = {
  E01: "E01", //-深色 绿色
  E02: "E02", //-深色 红色
  E03: "E03", //-深色 蓝色
  E04: "E04", //-深色 黑金
  E05: "E05", // 深色 亮绿色
  E06: "E06", //深色 墨绿
  E07: "E07", //-深色 翠绿
  E08: "E08", //浅色系-红色
  F01: "F01", //-绿紫色-E01二级页

  E001: "E001", //-浅色-粉色
};

export type TSkin = keyof typeof Skin;
